import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE } from "tools/webservice";
import { AppointmentCandidateResponse, AppointmentCandidateSubmission, SimpleResponse } from "interfaces/Mueller.Business.Models";

export const getAppraisalAppointment = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/appointment/${controlIdNumber}/appraisal`,
  successCallback,
  errorCallback,
  mountedRef
});

export const addAppraisalAppointment = (controlIdNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload,
  endpoint: `/appointment/${controlIdNumber}/appraisal`,
  successCallback,
  mountedRef
});

export const updateAppointmentNote = (controlIdNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload,
  endpoint: `/appointment/${controlIdNumber}/update-note`,
  successCallback,
  mountedRef
});

export const removeAppointment = (controlIdNumber, appointmentId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/appointment/${controlIdNumber}/remove/${appointmentId}`,
  successCallback,
  mountedRef
});

// This also available as an action in redux, see actions/caseAppointment
export const getCandidates = (controlIdNumber: number, successCallback: (response: AppointmentCandidateResponse) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/appointment/${controlIdNumber}/assignment-candidates`,
  successCallback,
  mountedRef
});

export const assignCandidate = (controlIdNumber: number, submission: AppointmentCandidateSubmission, successCallback: (response: SimpleResponse) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: submission,
  endpoint: `/appointment/${controlIdNumber}/assignment-candidates`,
  successCallback,
  errorCallback,
  mountedRef
});

export const sendConfirmation = (controlIdNumber: number, contacts: string[], successCallback: (response: SimpleResponse) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: contacts,
  endpoint: `/appointment/${controlIdNumber}/confirmation`,
  successCallback,
  mountedRef
});
